import styled from 'styled-components';

export const FileDetails = styled.div`
  margin-left: 12px;
  margin-right: 50px;
`;

export const Clickable = styled.div`
  color: var(--ds-icon-subtle, var(--ds-fb-icon-subtle));
  &:hover {
    cursor: pointer;
    color: ${() => 'var(--ds-icon, var(--ds-fb-icon))'};
  }
`;
